import styled from 'styled-components';
import AsyncTypeAheadField from 'components/forms/typeAheadField/AsyncTypeAheadField';

export const EmailSearchFieldAsyncTypeahead = styled(AsyncTypeAheadField)`
  .dropdown-menu {
    width: 260px !important;
  }
`;

export const EmailSearchOption = styled.div.attrs({
  className: 'email-search-option-container',
})`
  align-items: center;
  display: flex;
  padding: 0.4em;

  :hover {
    background-color: #f5f5f5;
  }
`;

export const LeadSearchDetails = styled.div`
  margin-left: 1em;
`;
